import { Box, Button, ButtonProps } from '@chakra-ui/react';
import React, { FC } from 'react';
import { CustomStarFilled } from '../../config/icons';

type HotelRatingButtonProps = ButtonProps & {
  rating: string;
  totalRatingCount: number;
};

const HotelRatingButton: FC<HotelRatingButtonProps> = ({
  rating,
  totalRatingCount,
  ...props
}) => {
  return (
    <Button
      cursor="pointer"
      as="span"
      marginY={{
        base: 2,
        md: 0,
      }}
      ml={{
        base: 0,
        md: 4,
      }}
      size="xs"
      colorScheme="yellow"
      variant="outline"
      {...props}
    >
      <CustomStarFilled fill="yellow.500" />
      <Box ml="2">
        {rating} ({totalRatingCount} Bewertungen)
      </Box>
    </Button>
  );
};

export default HotelRatingButton;
